import React,{Fragment,useContext,useEffect} from 'react'
import './pages.css'
import { NavBar } from '../components/NavBar'
import { TaskForm } from '../components/TaskForm'
import { FirebaseContext } from "../components/firebase/firebaseContext";
import { getDatabase, ref, onValue } from "firebase/database";


export const TaskPage = () => {
  const {notes,fetchNotes} = useContext(FirebaseContext)


  useEffect(()=>{
    fetchNotes()
    
  },[])
  console.log(fetchNotes)
  return (
    <Fragment>
    <div className="main">
    <NavBar/>
    <TaskForm notes={notes}/>
    </div>
   
  </Fragment>
  )
}

